var _filter, _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppropriatenessAssessmentQuestionTwelve(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-labelledby": titleId,
    width: 84,
    height: 83,
    viewBox: "0 0 84 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "brightness"
  }, /*#__PURE__*/React.createElement("feComponentTransfer", null, /*#__PURE__*/React.createElement("feFuncR", {
    type: "linear",
    slope: 0.65
  }), /*#__PURE__*/React.createElement("feFuncG", {
    type: "linear",
    slope: 0.65
  }), /*#__PURE__*/React.createElement("feFuncB", {
    type: "linear",
    slope: 0.65
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.594 83C64.5658 83 83.1881 64.4198 83.1881 41.5C83.1881 18.5802 64.5658 0 41.594 0C18.6223 0 0 18.5802 0 41.5C0 64.4198 18.6223 83 41.594 83Z",
    fill: "#242D33"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1301_3054)"
  }, /*#__PURE__*/React.createElement("path", {
    filter: "url(#brightness)",
    d: "M52.5909 43.9527C47.912 43.9527 44.1055 47.7592 44.1055 52.4381C44.1055 57.1171 47.912 60.9236 52.5909 60.9239C57.2698 60.9236 61.0764 57.1171 61.0764 52.4381C61.0764 47.7592 57.2698 43.9527 52.5909 43.9527ZM52.5909 51.1331C53.3107 51.1331 53.8963 51.7187 53.8963 52.4381C53.8963 53.1579 53.3107 53.7435 52.5909 53.7435C51.8714 53.7432 51.2856 53.1579 51.2856 52.4384C51.2856 51.7187 51.8711 51.1331 52.5909 51.1331Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5616 38.895C35.2405 38.8947 39.0471 35.0882 39.0471 30.4093C39.0471 28.1429 38.1645 26.0118 36.5617 24.4092C34.9591 22.8064 32.828 21.9238 30.5616 21.9238C30.5613 21.9238 30.5613 21.9238 30.5613 21.9238C28.2949 21.9238 26.1639 22.8064 24.5613 24.4092C22.9587 26.0118 22.0762 28.1429 22.0762 30.4093C22.0762 35.0882 25.8827 38.8947 30.5616 38.895ZM29.2566 30.4093C29.2566 29.6895 29.8421 29.1042 30.5616 29.1042C31.2811 29.1042 31.8667 29.6895 31.8667 30.4093C31.8667 31.129 31.2811 31.7143 30.5616 31.7143C29.8421 31.7143 29.2566 31.129 29.2566 30.4093Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0239 22.9754C59.3458 22.2972 58.4442 21.9238 57.4852 21.9238C56.5265 21.9238 55.625 22.297 54.9466 22.9754L23.1269 54.7947C21.7272 56.1947 21.7272 58.4721 23.1269 59.8721C23.805 60.5502 24.7069 60.9239 25.6659 60.9239C26.6249 60.9239 27.5264 60.5505 28.2045 59.8721L60.0239 28.0527C61.4239 26.6527 61.4239 24.375 60.0239 22.9754Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    filter: "url(#brightness)",
    d: "M60.0247 22.9754C59.3466 22.2972 58.445 21.9238 57.486 21.9238C56.5273 21.9238 55.6257 22.297 54.9473 22.9754L41.5762 36.3462V46.5009L60.0247 28.0527C61.4246 26.6527 61.4246 24.375 60.0247 22.9754Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1301_3054"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 39,
    fill: "white",
    transform: "translate(22 22)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppropriatenessAssessmentQuestionTwelve);
export default __webpack_public_path__ + "static/media/AppropriatenessAssessmentQuestionTwelve.58de48367c1bff7870dba71d50521e88.svg";
export { ForwardRef as ReactComponent };